import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/*
🔗  Linked to kayhof-outlookcoms-projects/kokun02 (created .vercel and added it to .gitignore)
🔍  Inspect: https://vercel.com/kayhof-outlookcoms-projects/kokun02/68y8sP3eZbvheUvW1sFFVAV1iD6K [2s]
✅  Production: https://kokun02-3pli38kn4-kayhof-outlookcoms-projects.vercel.app [2s]
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
